import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, defer } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { OverlayRef } from '@angular/cdk/overlay';

@Injectable({
  providedIn: 'root'
})
export class SpinningService {

  count$ = new BehaviorSubject<number>(0)
  
  constructor() {

  }
  startWith<T>(observable: Observable<T>) {
    return defer(() => {
      var count = this.count$.value;
      count++
      this.count$.next(count);
      return observable;
    }).pipe(
      finalize(() => {
        var count = this.count$.value;
        count--;
        this.count$.next(count);
      })
    )
  }
}
